var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShareIosLine = function SvgShareIosLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bi bi-box-arrow-up",
    width: 32,
    height: 32.001,
    fill: "currentColor",
    viewBox: "0 0 32 32.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 12.001a1 0.99998 0 0 0-1 0.99998v16a1 0.99998 0 0 0 1 0.99998h18a1 0.99998 0 0 0 1-0.99998v-16a1 0.99998 0 0 0-1-0.99998h-4a1 0.99998 0 0 1 0-2h4a3 2.9999 0 0 1 3 2.9999v16a3 2.9999 0 0 1-3 2.9999h-18a3 2.9999 0 0 1-3-2.9999v-16a3 2.9999 0 0 1 3-2.9999h4a1 0.99998 0 0 1 0 2z",
    fillRule: "evenodd",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.292 0.29378a1 0.99998 0 0 1 1.416 0l6 5.9999a1.0013 1.0012 0 0 1-1.416 1.416l-4.292-4.2939v17.586a1 0.99998 0 0 1-2 0v-17.586l-4.292 4.2939a1.0013 1.0012 0 1 1-1.416-1.416z",
    fillRule: "evenodd",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareIosLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-ios-line.545de1ab.svg";
export { ForwardRef as ReactComponent };